import VueRouter from 'vue-router'
import Vue from 'vue'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Customer from '@/pages/Customer'
import Business from '@/pages/Business'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/about',
      component: About
    },
    {
      path: '/customer',
      component: Customer
    },
    {
      path: '/business',
      component: Business
    }
  ]
})
